import React from 'react'
import { modalActions } from 'store/modal'
import { connect } from 'react-redux'
import Loader from 'components/D3Loader'
import { getBaseSiteIdFromStudy } from 'utils/misc'
import ClinroView from '../components/ClinroView'
import { clinroActions, duplicateItem, imageActions } from '../modules/Clinro'
import { instrumentActions, metadataActions } from '../../../modules/Instrument'
import { downloadInstrument } from '../../../../InstrumentsPage/modules/Instruments'
import { isVersionUatOrLive } from '../../../../../../../../../../../utils/studyConfigUtils'

const mapDispatchToProps = {
  duplicateItem,
  ...clinroActions,
  ...imageActions,
  ...instrumentActions,
  ...metadataActions,
  ...modalActions,
  downloadInstrument,
}

const mapStateToProps = (state, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  const path = state.location?.pathname === '/instruments/createclinro' ? 'create' : 'edit'
  const { instrumentReducer, clinroEditor, loading, study } = state
  const instrument = instrumentReducer?.instrument || {}
  const { type, title, url } = instrument
  const clinro = clinroEditor?.clinro

  const { studyVersionList } = state.study || {}
  const hasStudyPromotion = !!state?.study?.currentStudy?.config?.study_promotion
  const isReadOnlyState = hasStudyPromotion && isVersionUatOrLive(studyVersionList, studyVersionID)

  return {
    id: clinro?.id,
    type,
    url,
    instrumentTitle: title,
    clinro,
    article: clinroEditor?.article,
    isLoading: loading?.general,
    questionNumbers: clinro?.questionNumbers,
    wordCount: clinroEditor?.wordCount,
    version: instrument.metadata?.version ?? 1,
    path,
    studyID: study?.currentStudy?.id,
    siteID: getBaseSiteIdFromStudy(study),
    errors: clinroEditor?.clinroErrors,
    studyVersionID,
    isReadOnlyState,
    study: study?.currentStudy,
    reviewScreen: instrument.metadata?.review_screen?.enabled,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(props => {
  return props.isLoading ? <Loader active /> : <ClinroView {...props} />
})
